<!--
  Preparacion de la sesion. El pie de carga ya ocupa la pantalla entera y ya trae su
  marca, su rotulo y su barra: se le da el texto y no se le monta nada encima, que
  es lo que antes tapaba el aviso.

  Se superpone a la entrada mientras se aplica lo que el usuario tenia ajustado, de
  modo que el cambio de tema ocurra DETRAS y no a la vista.
-->
@if (preparandoSesion()) {
  <div class="preparando" role="status" aria-live="polite">
    <app-loader
      [duration]="1200"
      [statusText]="'LOGIN.LOADING_PREFERENCES' | translate"
    ></app-loader>
  </div>
}

<div class="login-container">
  <div class="login-top-actions">
    @if (languages().length > 0) {
      <div class="login-lang-selector">
        <button
          class="lang-btn"
          type="button"
          (click)="toggleLangMenu()"
          [title]="'LAYOUT.LANGUAGE' | translate"
        >
          <span class="lang-flag">{{ activeFlag() }}</span>
        </button>
        @if (langMenuOpen()) {
          <div class="lang-menu" role="menu">
            @for (l of languages(); track l.code) {
              <button
                class="lang-item"
                type="button"
                [class.active]="l.code === activeLang()"
                (click)="selectLanguage(l.code)"
              >
                <span class="lang-flag">{{ l.flagEmoji }}</span>
                <span class="lang-name">{{ l.nativeName }}</span>
              </button>
            }
          </div>
        }
      </div>
    }
    <button
      class="dark-mode-toggle"
      (click)="toggleDarkMode()"
      [attr.aria-label]="(isDarkMode() ? 'LOGIN.DARK_OFF' : 'LOGIN.DARK_ON') | translate"
    >
      <lib-icon [name]="isDarkMode() ? 'Sun' : 'Moon'" [size]="20"></lib-icon>
    </button>
  </div>

  <div class="background-overlay"></div>
  @if (!isMobile) {
    <div
      class="network-background"
      [style.background-image]="
        'url(' +
        (isDarkMode()
          ? 'assets/shell/wallpapers/nebula-background-dark.png'
          : 'assets/shell/wallpapers/nebula-background-light.png') +
        ')'
      "
    ></div>
  }

  <div class="content-wrapper" [class.mobile-view]="isMobile">
    @if (!isMobile) {
      @if (!isTablet) {
        <div class="brand-section"></div>
      }

      <form [formGroup]="form" class="login-form">
        <div class="brand-section">
          <img
            [src]="
              isDarkMode()
                ? 'assets/shell/logos/dark/logo-nebula-dark.svg'
                : 'assets/shell/logos/light/logo-nebula-light.svg'
            "
            alt="Nebula ERP"
            class="logo"
          />
        </div>

        <div class="divider"></div>

        <h2 class="form-title">{{ 'LOGIN.TITLE' | translate }}</h2>

        <lib-input
          formControlName="user"
          [required]="true"
          [label]="'LOGIN.USER' | translate"
          [placeholder]="'LOGIN.USER' | translate"
          [errorMsg]="getError('user')"
        ></lib-input>

        <lib-input
          formControlName="password"
          type="password"
          [label]="'LOGIN.PASSWORD' | translate"
          [required]="true"
          [placeholder]="'LOGIN.PASSWORD' | translate"
          [errorMsg]="getError('password')"
        ></lib-input>

        <section class="submit-wrapper">
          <lib-button
            type="submit"
            [loading]="loading()"
            [disabled]="form.invalid"
            (clicked)="onSubmit()"
            class="btn-login-submit"
          >
            {{ (loading() ? 'LOGIN.SIGNING_IN' : 'LOGIN.SIGN_IN') | translate }}
          </lib-button>
        </section>
        <br />

        <div class="forgot-password">
          <div class="forgot-text">{{ 'LOGIN.FORGOT' | translate }}</div>
          <a class="forgot-link" style="cursor: pointer" (click)="irARecuperar()">{{
            'LOGIN.FORGOT_LINK' | translate
          }}</a>
        </div>
      </form>

      @if (error()) {
        <div class="global-alert">
          <lib-alert
            type="error"
            [title]="error()!.TITLE"
            [message]="error()!.SUBTITLE"
          ></lib-alert>
        </div>
      }
    }

    @if (isMobile) {
      <div class="mobile-message">
        <img src="assets/shell/logos/logo-nebula.svg" alt="Nebula ERP" class="mobile-logo" />
        <p>{{ 'LOGIN.MOBILE' | translate }}</p>
      </div>
    }
  </div>
</div>
